import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

type EditIconProps = CreateIconComponentProps & {
  title?: string;
  viewBox?: string;
};

export const EditIcon = ({
  title = 'Pencil',
  viewBox = '0 0 18 18',
  ...props
}: EditIconProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox={viewBox} {...props} fill="none">
    <path
      d="M10.793 1.793a3.828 3.828 0 1 1 5.414 5.414l-10.5 10.5A1 1 0 0 1 5 18H1a1 1 0 0 1-1-1v-4a1 1 0 0 1 .293-.707l10.5-10.5ZM2 16h2.586L14.793 5.793a1.829 1.829 0 0 0-2.586-2.586L2 13.414V16Z"
      fill="currentColor"
    />
    <path
      d="M9.793 2.793a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414Z"
      fill="currentColor"
    />
  </CreateIconComponent>
);

export default EditIcon;
